import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { IMPLEMENTED_LANGUAGES } from './constants'

Vue.use(VueI18n)

function getParameterByName (name, url) {
    if (!url) url = window.location.href

    name = name.replace(/[\[\]]/g, '\\$&')

    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)

    if (!results) return null

    if (!results[2]) return ''

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function loadLocaleMessages () {
    const locales = require.context(
        './locales',
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    )
    const messages = {}

    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)

        if (matched && matched.length > 1) {
            const locale = matched[1]

            messages[locale] = locales(key)
        }
    })

    return messages
}

const lang = window.navigator &&
        (window.navigator.language ||
            window.navigator.systemLanguage ||
            window.navigator.userLanguage)

function isImplemented (specificLang) {
    if (specificLang) {
        for (const value of IMPLEMENTED_LANGUAGES) {
            if (specificLang.toLowerCase().match(value)) return true
        }
    } else {
        for (const value of IMPLEMENTED_LANGUAGES) {
            if (lang.toLowerCase().match(value)) return true
        }
    }

    return false
}

const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency',
            currency: 'USD'
        }
    },
    'ru': {
        currency: {
            style: 'currency',
            currency: 'RUB',
            currencyDisplay: 'code'
        }
    }
}

const queryLang = getParameterByName('lang')
export default new VueI18n({
    locale: queryLang ? (isImplemented(queryLang) ? 'ru' : 'en') : (isImplemented() ? 'ru' : 'en'),
    numberFormats,
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
})
